<script setup lang="ts">
import BlockingPage from "@/components/BlockingPage.vue";
</script>

<template>
  <BlockingPage
    header="Åtkomst nekad"
    paragraph="Något gick fel vid inloggningen. Vänligen försök logga in igen."
    action-text="Logga in"
    action-route="/signin"
    icon="i-material-symbols-lock-outline-rounded"
  />
</template>
